import {callApi} from '../api'

export const GET_VACATIONS = 'GET_VACATIONS';
export const EDIT_VACATION = 'EDIT_VACATION';
export const DELETE_VACATION = 'DELETE_VACATION';

export function getVacations(cb) {
    return function (dispatch, getState) {
        return callApi(dispatch, getState, 'GET', '/vacations', null, GET_VACATIONS, cb);
    }
}

export function editVacation(cb, vacationId, data) {
    return function (dispatch, getState) {
        return callApi(dispatch, getState, 'PATCH', '/vacations/' + vacationId, data, EDIT_VACATION, cb);
    }
}

export function deleteVacation(cb, vacationId) {
    return function (dispatch, getState) {
        return callApi(dispatch, getState, 'DELETE', '/vacations/' + vacationId, null, DELETE_VACATION, cb);
    }
}



// WEBPACK FOOTER //
// ./src/actions/vacations.js